import { normalizeProductName } from '../../shared/utils/product';

export const getIconComponentName = (product) => {
  return normalizeProductName(product);
};

export const IconSettings = {
  ['Dashboard']: {
    activeColor: '#1E5AFF',
    activeBackground: 'linear-gradient(132.77deg, #1E5AFF 38.99%, #1F4FFB 100%)',
  },
  ['SSWebApp']: {
    activeColor: '#6100DC',
    activeBackground: 'linear-gradient(134.29deg, #6100DC 33.01%, #6100DC 101.27%)',
  },
  ['Media Planner']: {
    activeColor: '#FC2197',
    activeBackground: 'linear-gradient(134.29deg, #FC2197 33.01%, #CA0085 101.27%)',
  },
  ['Instant IO']: {
    activeColor: '#B43AFF',
    activeBackground: 'linear-gradient(133.78deg, #B43AFF 29.8%, #9306E9 97.96%)',
  },
  ['Orders']: {
    activeColor: '#36B20B',
    activeBackground: 'linear-gradient(137.29deg, #36B20B 35.93%, #238900 100%)',
  },
  ['Help Center']: {
    activeColor: '#E30A7B',
    activeBackground: 'linear-gradient(137.29deg, #E30A7B 35.93%, #E30A7B 100%)',
  },
  ['Placements']: {
    activeColor: '#05848D',
    activeBackground: 'linear-gradient(134.29deg, #06949E 33.01%, #05848D 101.27%)',
  },
  ['Management Reporting']: {
    activeColor: '#C0E94D',
    activeBackground: 'linear-gradient(134.29deg, #C0E94D 33.01%, #8BF324 101.27%)',
  },
  ['Creative Gallery']: {
    activeColor: '#FFD02A',
    activeBackground: 'linear-gradient(134.29deg, #FFD02A 33.01%, #FFAC27 101.27%)',
  },
  ['Advanced Performance']: {
    activeColor: '#00A058',
    activeBackground: 'linear-gradient(134.29deg, #01C56D 33.01%, #00A058 101.27%)',
  },
};
